import { render, staticRenderFns } from "./ServiceQualification.vue?vue&type=template&id=c04bef70&scoped=true"
import script from "./ServiceQualification.vue?vue&type=script&lang=js"
export * from "./ServiceQualification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c04bef70",
  null
  
)

export default component.exports